import { createFileRoute } from "@tanstack/react-router";
import { AuditEventPage } from "@/features/audit/audit-event-page";

export const Route = createFileRoute("/_authenticated/audit/$eventId")({
  head: () => ({ meta: [{ title: "Audit event · Rogue Admin" }] }),
  component: AuditEventPage,
});
